export enum SidebarEnum {
  Versioning = 'versioning',
  Comments = 'comments',
}

export const EDITOR_STATUS = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  ERROR: 'error',
  INITIALIZING: 'initializing',
  SYNCED: 'synced',
};

export type EditorStates = {
  isLoading: boolean;
  errorMessage: string | null;
  response: string | null;
};
